"use client";

import { useTranslation } from "react-i18next";
import InfoSection from "./InfoSection";

type TranslatedInfoSectionProps = {
  items: string[];
};

export default function TranslatedInfoSection({
  items,
}: TranslatedInfoSectionProps) {
  const { t } = useTranslation();

  return <InfoSection title={t("Amenities")} items={items} />;
}

